import React from "react";

import StepDeliveryAddress from "../components/pages/HeatingOil/CheckoutPage/StepDeliveryAddress";
import StepDeliveryDetails from "../components/pages/HeatingOil/CheckoutPage/StepDeliveryDetails";
import StepOverview from "../components/pages/HeatingOil/CheckoutPage/StepOverview";
import StepPaymentType from "../components/pages/HeatingOil/CheckoutPage/StepPaymentType";
import StepProductChoice from "../components/pages/HeatingOil/CheckoutPage/StepProductChoice";
import StepSuccess from "../components/pages/HeatingOil/CheckoutPage/StepSuccess";

/**
 * Text for the stepper.
 */
export const stepText = {
    deliveryAdress: "Lieferadresse",
    deliveryDetails: "Lieferdetails",
    overview: "Zusammenfassung",
};

/**
 * Available Checkout steps.
 */
const checkoutSteps = [
    {
        step: null,
        text: null,
        component: <StepProductChoice />,
        url: "produkt",
    },
    {
        step: 1,
        text: stepText.deliveryDetails,
        component: <StepDeliveryDetails />,
        url: "lieferdetails",
    },
    {
        step: 2,
        text: stepText.deliveryAdress,
        component: <StepDeliveryAddress />,
        url: "lieferadresse",
    },
    {
        step: 3,
        text: stepText.deliveryDetails,
        component: <StepPaymentType />,
        url: "zahlart",
    },
    {
        step: 3,
        text: stepText.overview,
        component: <StepOverview />,
        url: "uebersicht",
    },
    {
        step: null,
        text: null,
        component: <StepSuccess />,
        url: "erfolg",
        crossSelling: true,
    },
];

export default checkoutSteps;
